import { host, crawlerHost } from './helper/config';

// API configuration using environment variables
const config = {
  server: {
    url: host, // Gets value from REACT_APP_API_HOST or defaults based on NODE_ENV
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    endpoint: {
      graphql: 'graphql',
      login: 'login',
      sql: 'sql'
    }
  }
};

export default config;

export const API_URL_CRAWLER = crawlerHost;

